require('angular');
require('./cn/cn.js');
require('./login/login.js');
require('./lib/notifications/notifications.js');
require('./lib/loading/loading.js');

angular.module('accountsv2', ['ngRoute', 'ui.bootstrap', 'notifications', 'focus-if', 'loading', 'cn', 'login']);

angular.module('accountsv2')

// test to improve performance
.config(['$httpProvider', function($httpProvider) {
  $httpProvider.useApplyAsync(true);
}])

// turn off $q errores of possibly unhandler exceptions
.config(['$qProvider', function($qProvider) {
  $qProvider.errorOnUnhandledRejections(false);
}])

.config(['$routeProvider', function($routeProvider) {
  $routeProvider
  .when('/', {
    constoller: 'none',
    redirectTo: '/networks'
  });
}])

// Olapic Logo
.component('olapicLogo', {
  template: require('./olapic-logo.html')
})

.constant('ENV', {
  EIAM_URL: '/eiam'
});



// WEBPACK FOOTER //
// ./src/app.js